import React, { useState } from 'react'
import { FaSistrix } from 'react-icons/fa'
import {BsGlobe,} from 'react-icons/bs'
import { NavLink } from 'react-router-dom'
import {  Box, Button, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex, Heading, Image, Input, Menu, MenuButton, MenuItem, MenuList, Spacer, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useDisclosure, VStack,  } from '@chakra-ui/react'
import DrawerProducts from '../Drawer/DrawerProducts'
import DrawerResources from '../Drawer/DrawerResources'
import DrawerInspiration from '../Drawer/DrawerInspiration'
import Profile from '../Pages/Profile'
import { useContext } from 'react'
import { AuthContext } from '../Context/AuthContext'
function Navbar() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = React.useRef()
    const [colorChange, setColorchange] = useState(false);
    const {usname} = useContext(AuthContext)
    
    const changeNavbarColor = () =>{
       if(window.scrollY >= 80){
         setColorchange(true);
       }
       else{
         setColorchange(false);
       }
    };
    window.addEventListener('scroll', changeNavbarColor);
  return (
    <>
      <Flex position="sticky" top="0" zIndex="10"  _hover={{bgColor:"white"}} bgColor={!colorChange ? "#ffe01b" : "white"} p="2.5rem 2rem" display="flex" alignItems="center"  height="4rem">
          <Box  display="flex" gap="1rem" alignItems="center">
            <Tabs variant='unstyled'>
              <TabList pt="2rem">
                <Tab >
                    <DrawerProducts />
                </Tab>
                <Tab>
                    <DrawerResources/>
                </Tab>
                <Tab>
                    <DrawerInspiration/>
                </Tab>
                <Tab>
                    <Button variant="link" colorScheme="black"><NavLink to="/pricing/marketing">Pricing</NavLink></Button>
                </Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                    
                </TabPanel>
                <TabPanel>
                  
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
          <Spacer/>
          <Box>
            <NavLink to="/">
              <Image width="140px" height="90px" src="https://logos-world.net/wp-content/uploads/2021/02/Mailchimp-Logo-2018-present.png" alt=""/>
            </NavLink>
          </Box>
          <Spacer/>
          <Box w="35%" display="flex" gap="1rem" alignItems="center">
            <Text _hover={{color:"teal", cursor:"pointer",textDecoration:"underline"}}>Sales: <br/>+1 (800) 315-5939</Text>
            <Box >
            <Menu>
              <MenuButton _hover={{color:"teal", cursor:"pointer"}}>
                <BsGlobe fontSize="24px" />
              </MenuButton>
              <MenuList>
                <MenuItem>English</MenuItem>
                <MenuItem>Espanol</MenuItem>
                <MenuItem>Portugues</MenuItem>
                <MenuItem>Deutsch</MenuItem>
                <MenuItem>Italiano</MenuItem>
              </MenuList>
            </Menu>
            </Box>
            <Box _hover={{color:"teal", cursor:"pointer"}}>
              <Box ref={btnRef} onClick={onOpen}>
                <FaSistrix fontSize="24px"/>
              </Box>
              <Drawer
                 
                 size="full"
                  isOpen={isOpen}
                  placement='top'
                  onClose={onClose}
                  finalFocusRef={btnRef}
                >
                  <DrawerOverlay />
                  <DrawerContent color="white" bgColor="#241c15">
                  
                  <DrawerBody mt="7%" >
                    <VStack spacing={10} >
                        <Box  w="90%" display="flex" alignItems="center">
                          <Box m="auto" w="80%" h="60px" border="1px solid white" display="flex" justifyContent="space-evenly" alignItems="center">
                            <Input variant="unstyled" w="90%" h="100%" fontSize="3xl" borderColor="none" placeholder='Search Mailchimp'  /><FaSistrix _hover={{color:"teal"}} fontSize="24px"/>
                          </Box>
                          <Box>
                            <Button _hover={{color:"teal", bgColor:"#241c15"}} variant='ghost' mr={3} onClick={onClose}>
                              <Text fontWeight="300" fontSize="4xl">X</Text>
                            </Button>
                          </Box>
                        </Box>
                        <Box  w="81%" p="1rem" textAlign="left">
                          <Box  mb="2rem"><Heading size="md" fontWeight="400">TRY SEARCHING FOR</Heading></Box>
                          <Box flexWrap="wrap" display="flex" justifyContent="left" gap="10px">
                            <Box _hover={{cursor:"pointer"}} border="1px solid white"><Text fontSize="30px" p=".3rem 3rem">email templates</Text></Box>
                            <Box _hover={{cursor:"pointer"}} border="1px solid white"><Text fontSize="30px" p=".3rem 3rem">newsletter</Text></Box>
                            <Box _hover={{cursor:"pointer"}} border="1px solid white"><Text fontSize="30px" p=".3rem 3rem">integrations</Text></Box>
                            <Box _hover={{cursor:"pointer"}} border="1px solid white"><Text fontSize="30px" p=".3rem 3rem">quickbooks</Text></Box>
                            <Box _hover={{cursor:"pointer"}} border="1px solid white"><Text fontSize="30px" p=".3rem 3rem">pricing plans</Text></Box>
                          </Box>
                        </Box>
                    </VStack>
                    <Image alt="" onClick={onClose} w="100%" height="200px" src="https://user-images.githubusercontent.com/99709824/180365622-81741900-2288-41bb-b97b-c945855fe83d.png"/>
                  </DrawerBody>
                  </DrawerContent>
              </Drawer>
            </Box>
            <Box  borderLeft={usname.current ? "1px solid blue" : "none"} justifyContent="center" h="40px" w="50%" display="flex" alignItems="center">
              <Profile/>
            </Box>
             </Box>
      </Flex>
    </>
  )
}

export default Navbar